import { vitalThresholds } from "../constants/vitalThresholds";

interface IRRValues {
  value: string;
  color: string;
}

interface IRRPreview {
  rr: IRRValues;
  rrChange: IRRValues;
  rrChangePercentage: IRRValues;
}

type IGetPsnRRData = (rrObj: IPsnRespRate) => IRRPreview;

const appendSignToDisplay = (value: number) => {
  if (!value || isNaN(value)) return "-";

  return value > 0 ? `+${Math.round(value)}` : `${Math.round(value)}`;
};

const appendSignToDisplayRRChange = (value: number) => {
  if (!value || isNaN(value)) return "-";

  return value > 0
    ? `+${Number(value).toFixed(1)}`
    : `${Number(value).toFixed(1)}`;
};

export const getBP = (systolic: number | null, diastolic: number | null) => {
  let color = "black";
  let value = "";

  if (systolic && diastolic) {
    // Format the display value
    value = `${Math.round(systolic)}/${Math.round(diastolic)}`;

    // Check for Stage 1 hypertension or higher conditions
    if (
      systolic >= 130 || // Stage 1 and above
      diastolic >= 80 // Stage 1 and above
    ) {
      color = "red";
    }
  }

  return { color, value };
};

export const getO2 = (o2: number | null) => {
  let color = "black";
  let value = "";

  if (o2) {
    value = `${o2}%`;
    if (o2 < vitalThresholds.o2.upper) {
      color = "red";
    }
  }

  return { color, value };
};

export const getRR = (rr: number | null) => {
  const rrUpperLimit = vitalThresholds.rr.upper;
  const rrLowerLimit = vitalThresholds.rr.lower;

  let color = "black";
  let value = "";

  if (rr) {
    if (Math.round(rr) >= rrUpperLimit || Math.round(rr) <= rrLowerLimit)
      color = "red";
    value = Math.round(rr).toString();
  }
  return { color, value };
};

export const getPsnRRData: IGetPsnRRData = (rrObj) => {
  const obj: IRRPreview = {
    rr: getRR(rrObj?.rr),
    rrChange: {
      color: "black",
      value: appendSignToDisplayRRChange(Number(rrObj?.rr_change)),
    },
    rrChangePercentage: {
      color: "black",
      value: `${appendSignToDisplay(
        Math.trunc(
          Number(rrObj?.rr_change_percentage?.toString().replace(/%/g, ""))
        )
      )}%`,
    },
  };
  return obj;
};

export const getArrowDirection = (rrObj: IPsnRespRate) => {
  if (Number(rrObj?.rr_change) === 0) return null;
  return Number(rrObj?.rr_change) > 0 ? "up" : "down";
};

export const getArrowDirectionColor = (rrObj: IPsnRespRate) => {
  const rrChangeUpperLimit = 3;
  const color = "black";
  if (Number(rrObj?.rr_change) >= rrChangeUpperLimit) return "red";
  return color;
};
